import React, {Component} from 'react'
import _ from 'lodash'
import {Col, Icon, Row} from 'rsuite'
import Timer from './Timer'

import {StyledButton, StyledQuestionButtonNavigate, StyledSummaryContainer} from '../styled/StyledQuestionComponents'
import ModalConfirmSendAnswers from './ModalConfirmSendAnswers'


class QuestionarySummary extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showConfirmModal: false,
        }
        this.checkAnswers = this.checkAnswers.bind(this)
        this.checkSaved = this.checkSaved.bind(this)

        this.closeConfirmModal = this.closeConfirmModal.bind(this)
        this.confirmSendAnswers = this.confirmSendAnswers.bind(this)

    }

    // verifica se a questão já possui resposta ou nao
    checkAnswers(questionCode) {

        const answer = this.props.answers
        if (_.isEmpty(answer)) {
            return !_.isEmpty(answer)
        } else {
            if (answer[questionCode] && answer[questionCode] !== '') {
                return !_.isEmpty(answer)
            }
            return false
        }

    }

    // verifica se a questão foi salva ou nao
    checkSaved(questionCode) {
        const {savedQuestions} = this.props
        if (!!savedQuestions[questionCode]) {
            return true
        } else {
            return false
        }
    }

    confirmSendAnswers() {
        this.setState({showConfirmModal: true})
    }

    closeConfirmModal() {
        this.setState({showConfirmModal: false})
    }


    render() {
        const {questions, answers, savedQuestions} = this.props

        const copy = [...questions]
        const rest = copy.splice(Math.ceil(copy.length / 2))


        const statusItem = (questionsList, offset = 0) => questionsList && questionsList.map((item, key) => {
            const isAnswered = answers && this.checkAnswers(item.code)
            const isSaved = savedQuestions && this.checkSaved(item.code)

            return (
                <div className={'status'} key={'question-div-' + key}>
                    <StyledQuestionButtonNavigate key={offset + key} isCorrect={null}
                                                  questionDetails={item} isAnswered={isAnswered}
                                                  isSaved={isSaved}
                                                  onClick={() => this.props.returnToQuestionNavigation(offset + key)}
                    >
                        {`${(offset + key + 1)}`.padStart(2, '0')}
                    </StyledQuestionButtonNavigate>
                    <div className={'text-status'}>
                        {
                            isAnswered ?
                                <span> Respondida</span> :
                                <span> Ainda não respondida</span>
                        }
                        {
                            isSaved &&
                            <span>/ Questão Salva </span>
                        }

                    </div>
                </div>
            )
        })
        const mockInfo = {
            type: 'Simulado'
        }
        const {title} = this.props.questionaryInfo

        return (
            <div>
                <StyledSummaryContainer>

                    <div className={'summary-title'}>
                        <h1>{mockInfo.type}: <span> {title} </span></h1>
                        <p>Resumo de tentativas</p>
                    </div>
                </StyledSummaryContainer>

                <StyledSummaryContainer
                    flex
                >

                    <div className={'card'}>{statusItem(copy)}</div>
                    <div className={'card'}>{statusItem(rest, copy.length)}</div>
                    <Row className='timer'>
                        <Col md={24}>
                            {this.props.hasTime &&
                            <Timer
                                minutes={this.props.minutes}
                                seconds={this.props.seconds}
                            />
                            }
                        </Col>
                    </Row>
                    <Row className={'buttons'}>
                        <Col md={12}>
                            <StyledButton
                                appearance="ghost"
                                onClick={() => this.props.showSummary()}
                            >
                                <Icon icon='long-arrow-left' size="lg"/> Retornar à tentativa

                            </StyledButton>
                        </Col>
                        <Col md={12}>
                            <StyledButton
                                color={'green'}
                                appearance="defaut"
                                onClick={() => this.confirmSendAnswers()}
                            >
                                Enviar tudo e finalizar
                            </StyledButton>
                        </Col>

                    </Row>

                </StyledSummaryContainer>


                <ModalConfirmSendAnswers
                    showConfirmModal={this.state.showConfirmModal}
                    closeConfirmModal={this.closeConfirmModal}
                    sendAnswers={this.props.sendAnswers}
                />


            </div>
        )
    }
}

export default QuestionarySummary



// WEBPACK FOOTER //
// ./src/components/_ead/_contentTypes/QuestionsNew/_components/QuestionarySummary.js